<script setup lang="ts">

import { computed } from "vue";
import { useNotify } from '@library/Components';
import { useDealerModeApi } from '@app/DealerMode/Types/Api/DealerModeApi';
import type{ IFormModel } from "@library/Components/Forms/Form";
import type { IDealerModeVehicle } from "@app/DealerMode/Types/IDealerModeVehicle";

type Props = { vehicle: IDealerModeVehicle, form: IFormModel };
const { vehicle, form } = defineProps<Props>();
const canSendSms = computed( () => form.isValid );
let numberOfSends = 0;

/**
 * Sends the SMS
 */
async function sendSms()
{

    if( numberOfSends > 2 )
    {
        await useNotify( 'Welcome SMS cannot be repeatedly sent.  Please wait before sending again.', 'Welcome To Carbucks' )
        return;
    }

    const api = useDealerModeApi();
    const result = await api.resendWelcomeSms( vehicle, vehicle.mobile! );
    if( result.success && result.data.wasSuccessful )
    {
        await useNotify( 'Welcome SMS was sent successfully', 'Welcome To Carbucks' );
        numberOfSends += 1;
        return;
    }
    await useNotify( '<div class="w-full 3xl:max-w-[30rem] 3xl:m-auto">Unable to send the Welcome SMS.  Please check the mobile number and try again</div>', 'Welcome To Carbucks' )
}

</script> 

<template>

    <div class="flex flex-col gap-4 3xl:gap-6">

        <MobilePhoneTextField
            v-model="vehicle.mobile"
            label="Customer's Mobile"
            required
            hide-details="auto"
        />

        <button class="flex flex-col justify-center items-center rounded p-4 gap-1
                    cursor-pointer transition-all
                    bg-white/10 hover:brightness-110"
                :class="{ 'opacity-20 !bg-white/10': canSendSms == false }"
                v-ripple
                @click="() => sendSms()">

            <h1 class="flex items-center uppercase 3xl:text-xl leading-[1.2] font-bold">
                Resend Welcome SMS
            </h1>
        
            <div class="text-sm 3xl:text-lg opacity-60 leading-[1.2]">
                Send an SMS to the customer with a link to download the app
            </div>

        </button>

    </div>

</template>